<template>
  <v-app v-if="asuulga">
    <v-container fluid class="py-0">
      <v-row no-gutters>
        <h3 class="text-primary">{{ asuulga.title }}</h3>
        <v-spacer></v-spacer>
        <v-radio-group v-model="femaleORmale" row mandatory>
          <v-radio label="Бүгд" value="all"></v-radio>
          <v-radio label="Эмэгтэй" value="female"></v-radio>
          <v-radio label="Эрэгтэй" value="male"></v-radio>
        </v-radio-group>
      </v-row>
      <p>
        <strong>Асуулга өгсөн тоо</strong>: {{ asuulga.numberOfVotes }} 
      </p>
    </v-container>
    <v-container fluid v-if="loading == false" class="py-0 mx-0">
      <div v-for="dep in departments" :key="dep.id">
        <asuulga-chart
          :categories="categories"
          :xcategories="_getAsuulgaDepartmentCategories(dep)"
          :femaleORmale="femaleORmale"
          :asuulgaDepartment="_getAsuulgaDepartment(dep)"
          :department="dep"
        ></asuulga-chart>
      </div>
      <!-- <asuulga-chart
        :categories="categories"
        :xcategories="categories"
        :femaleORmale="femaleORmale"
      ></asuulga-chart> -->
    </v-container>
    <div v-else style="position: fixed; z-index: 10000000; top: 45%; left: 45%">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import AsuulgaChart from "./AsuulgaChart";
const fb = require("../../../firebaseConfig.js");
export default {
  components: {
    AsuulgaChart,
  },
  data: () => ({
    isGrid: true,
    tab: null,
    asuulga: null,
    categories: null,
    prePath: null,
    loading: false,
    school: null,
    bgDetailColor: "#ececec",
    asuulgaDepartments: null,
    allAnswers: null,
    femaleORmale: "all",
    departments: null,
  }),
  props: {
    schoolId: {
      type: String,
      required: true,
    },
    asuulgaId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  created() {
    this._getData();
  },
  methods: {
    _getAsuulgaDepartmentCategories(department) {
      if (this.asuulgaDepartments != null) {
        for (const dep of this.asuulgaDepartments) {
          if (dep.id == department.id) return dep.categories;
        }
      }
      return null;
    },
    _getAsuulgaDepartment(department) {
      if (this.asuulgaDepartments != null) {
        for (const dep of this.asuulgaDepartments) {
          if (dep.id == department.id) return dep;
        }
      }
      return null;
    },
    _getDepartment(asuulgaDepartment) {
      for (const dep of this.departments) {
        if (dep.id == asuulgaDepartment.id) return dep;
      }
      return null;
    },
    _getDepartments(startYear) {
      if (this.school != null) {
        this.school.ref
          .collection("departments")
          .where("startYear", "==", startYear)
          .orderBy("createdAt", "desc")
          .onSnapshot((querySnapshot) => {
            this.departments = [];
            querySnapshot.forEach((doc) => {
              this.countOfPrograms = 0;
              let dep = doc.data();
              dep.id = doc.id;
              dep.ref = doc.ref;
              this.departments.push(dep);
            });
          });
      }
    },
    async _getData() {
      this.prePath = "/schools/" + this.schoolId + "/asuulga/";
      this.loading = true;
      var ss = await fb.db.doc("schools/" + this.schoolId).get();
      if (ss.exists) {
        this.school = ss.data();
        this.school.id = ss.id;
        this.school.ref = ss.ref;
        this._getDepartments(this.school.currentYear);
      }
      fb.db
        .collection(this.prePath)
        .doc(this.asuulgaId)
        .onSnapshot(async (doc) => {
          if (doc.exists) {
            this.asuulga = doc.data();
            this.asuulga.ref = doc.ref;
            this.asuulga.id = doc.id;
            await this._findDepartments(this.asuulga);
            await this._findCategories(this.asuulga, this.categories);
          } else {
            console.log("No such document!");
          }
        }) 
      this.loading = false;
    },
    _getQuestionsOfCategory(cat) {
      cat.ref.collection("questions").onSnapshot((querySnapshot) => {
        cat.questions = [];
        querySnapshot.forEach((doc) => {
          let question = doc.data();
          question.id = doc.id;
          question.answers = null;
          doc.ref.collection("answers").onSnapshot((querySnapshot) => {
            question.answers = [];
            querySnapshot.forEach((doc) => {
              let answer = doc.data();
              answer.id = doc.id;
              question.answers.push(answer);
            });
          });
          cat.questions.push(question);
        });
      });
    },
    async _findDepartments(asuulga) {
      asuulga.ref.collection("/departments").onSnapshot((querySnapshot) => {
        this.asuulgaDepartments = [];
        querySnapshot.forEach((doc) => {
          let dep = doc.data();
          dep.id = doc.id;
          dep.ref = doc.ref;
          dep.categories = null;
          dep.ref.collection("/categories").onSnapshot((querySnapshot) => {
            dep.categories = [];
            querySnapshot.forEach((doc) => {
              const cat = doc.data();
              cat.id = doc.id;
              cat.ref = doc.ref;
              cat.questions = null;
              this._getQuestionsOfCategory(cat);
              dep.categories.push(cat);
            });
          });

          this.asuulgaDepartments.push(dep);
        });
      });
    },
    async _findCategories(asuulga) {
      asuulga.ref
        .collection("/categories")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.categories = [];
          querySnapshot.forEach((doc) => {
            const cat = doc.data();
            cat.id = doc.id;
            cat.ref = doc.ref;
            cat.questions = [];
            this._getQuestionsOfCategory(cat);
            this.categories.push(cat);
          });
        });
    },
  },
};
</script>
<style>
.theme--light.v-tabs-items {
  background-color: #eeeeee;
}
</style>